module.exports = __webpack_public_path__ + "img/Wing_feathers_Normal.e3595a5.png";